import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Router } from '@angular/router';
import { SecureSessionService } from './services/secure-session.service';
import { AuthService } from './services/auth.service';
import { CommonService } from './services/common.service';
import { StudentService } from './services/student.service';
import { MyProfileService } from './hrms/services/my-profile.service';
import { FeatureFlagService } from './services/feature-flag.service';

export interface PeriodicElement {
  className: string;
  date: string;
  time: string;
  staffName: string
}

interface NewEvent {
  title: string;
  start: string;
  extendedProps: {
    description: string;
  };
}

@Injectable({
  providedIn: 'root'
})

export class SharedService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  private roles: string[] = []; // Store roles after login
  loginData: any;
  sessionData: any;
  sessionStorage: any;

  sessionDataChild: any;
  sessionStorageChild: any;

   private firstLoginSubject = new Subject<boolean>();
  firstLogin$ = this.firstLoginSubject.asObservable();


  private _loginUrl = "Login/login";
  constructor(
    private router: Router,
    private session: SecureSessionService,
    private _login: AuthService,
    private _profile: MyProfileService,
    private _common: CommonService,
    private _featureFlag: FeatureFlagService
  ) { }

  // login(username: string, password: string): boolean {
  //   
  //   let status=false;
  //   this._login.login({ emailorPhone: username,
  //     password: password}).subscribe(res => {
  //       console.log(res);
  //       if(res.role=='Admin')
  //       {
  //         this.roles = ['admin'];
  //         this.loginData=['admin'];
  //         const loginDataString = JSON.stringify(this.loginData);
  //         localStorage.setItem("loginData", loginDataString);  
  //         this.sessionData=[{role:'admin',schoolId:'1'}];
  //         const sessionStorage = JSON.stringify(this.sessionData);
  //         this.session.setSession(sessionStorage);   
  //         this.router.navigate(['/admin']);
  //        status = true;
  //       }
  //       else if(res.role=='Teacher')
  //       {
  //         this.roles = ['teacher'];
  //         this.loginData=['teacher'];
  //         const loginDataString = JSON.stringify(this.loginData);
  //         localStorage.setItem("loginData", loginDataString);
  //         this.sessionData=[{role:'teacher',schoolId:'1'}];
  //         const sessionStorage = JSON.stringify(this.sessionData);
  //         this.session.setSession(sessionStorage);
  //        this.router.navigate(['/teacher']);
  //        status = true;
  //       }else if(res.role=='Parent')
  //       {
  //         this.roles = ['parent'];
  //         this.loginData=['parent'];
  //         const loginDataString = JSON.stringify(this.loginData);
  //         localStorage.setItem("loginData", loginDataString);
  //         this.sessionData=[{role:'parent',schoolId:'1'}];
  //          const sessionStorage = JSON.stringify(this.sessionData);
  //          this.session.setSession(sessionStorage);
  //         this.router.navigate(['/parent']);
  //        status = true;
  //       }else if(res.role=='Transport')
  //       {
  //         this.roles = ['transport'];
  //     this.loginData=['transport'];
  //     const loginDataString = JSON.stringify(this.loginData);
  //     localStorage.setItem("loginData", loginDataString);
  //     this.sessionData=[{role:'transport',schoolId:'1'}];
  //      const sessionStorage = JSON.stringify(this.sessionData);
  //      this.session.setSession(sessionStorage);
  //     this.router.navigate(['/transport']);
  //     status = true;
  //       }
  //       else if (username === 'admin@gmail.com' && password === 'admin') {
  //         this.roles = ['admin'];     
  //         this.loginData=['admin'];
  //         const loginDataString = JSON.stringify(this.loginData);
  //         localStorage.setItem("loginData", loginDataString);
  //         this.sessionData=[{role:'admin',schoolId:'1'}];
  //         const sessionStorage = JSON.stringify(this.sessionData);
  //         this.session.setSession(sessionStorage);
  //         this.router.navigate(['/admin']);
  //        status = true;
  //       } else if (username === 'teacher@gmail.com' && password === 'teacher') {
  //         this.roles = ['teacher'];       
  //          this.loginData=['teacher'];
  //          const loginDataString = JSON.stringify(this.loginData);
  //          localStorage.setItem("loginData", loginDataString);
  //          this.sessionData=[{role:'teacher',schoolId:'1'}];
  //          const sessionStorage = JSON.stringify(this.sessionData);
  //          this.session.setSession(sessionStorage); 
  //         this.router.navigate(['/teacher']);
  //       status = true;
  //       } else if (username === 'parent@gmail.com' && password === 'parent') {
  //         this.roles = ['parent'];
  //         this.loginData=['parent'];
  //         const loginDataString = JSON.stringify(this.loginData);
  //         localStorage.setItem("loginData", loginDataString);
  //         this.sessionData=[{role:'parent',schoolId:'1'}];
  //          const sessionStorage = JSON.stringify(this.sessionData);
  //         this.session.setSession(sessionStorage);    
  //         this.router.navigate(['/parent']);
  //        status = true;
  //       }
  //       else if (username === 'transport@gmail.com' && password === 'transport') {
  //         this.roles = ['transport'];
  //         this.loginData=['transport'];
  //         const loginDataString = JSON.stringify(this.loginData);
  //         localStorage.setItem("loginData", loginDataString);
  //         this.sessionData=[{role:'transport',schoolId:'1'}];
  //          const sessionStorage = JSON.stringify(this.sessionData);
  //          this.session.setSession(sessionStorage);
  //         this.router.navigate(['/transport']);
  //        status = true;
  //       }
  //       status=false;
  //     }, error => {
  //       console.error('Error submitting form', error);
  //       this._common.openSnackBarError('Username or password does not match, try again');
  //      status = false;
  //     });
  //  return status;
  // }

  login(username: string, password: string, consentVersion?: number, consentUpdatedDate?: string): Promise<boolean> {

    this.loadingSubject.next(true);
    return new Promise((resolve, reject) => {

      this._login.login({ emailorPhone: username, password: password, consentVersion: consentVersion, consentUpdatedDate: consentUpdatedDate })
        .subscribe(data => {
          let status = false;
          const res=data.data;

          this.roles = res.roles;
          this.loginData = res.roles;
          localStorage.setItem("loginData", JSON.stringify(this.loginData));
          this.session.setToken(res.token);
          this.sessionData = [{
            roles: res.roles,
            schoolId: res.schoolId,
            id: res.id,
            email: res.email,
            mobile: res.mobile,
            academicYearId: res.academicYearId
          }];
          this.session.setSession(JSON.stringify(this.sessionData));
          if (res.noraPulse) {
            this._featureFlag.setFlags(res.noraPulse);
          }
            // res.isFirstLogin=true;
           this.firstLoginSubject.next(res.isFirstLogin === true);


          if (res.roles && res.roles.length > 0) {
            this.router.navigate(['/nora']);
          } else {
            console.warn('No roles assigned. Redirecting to login.');
            this.router.navigate(['/login']);
          }

          resolve(status);
          setTimeout(() => {
            this.loadingSubject.next(false);
          }, 5000); // 300000 milliseconds = 5 minutes

          // this.loadingSubject.next(false);
        }, error => {


          this.loadingSubject.next(false);
          console.error('Error submitting form', error);
          this._common.openSnackBarError('Username or password does not match, try again');
          reject(false);


        });
    });
  }


  logout(): void {
    this.roles = [];
    // Clear only authentication and session data.
    // Report preferences (favourites, last-used states, column choices) are
    // intentionally preserved so they can be restored when the same user
    // logs back in from the same browser.
    this.session.clearSession(); // removes: session, sessionChild, authToken, loginData
    this._featureFlag.clearFlags();
    this._profile.resetProfileImage();
    this.router.navigate(['/login']);
  }

  isLoggedIn(): boolean {
    const loginData = localStorage.getItem("loginData");
    this.roles = loginData ? JSON.parse(loginData) : [];
    return this.roles.length > 0;
  }

  hasRole(role: string): boolean {
    return this.roles.includes(role);
  }

  getRoles(): any {
    const loginData = localStorage.getItem("loginData");
    this.roles = loginData ? JSON.parse(loginData) : [];
    return this.roles[0]
  }

  private paramSource = new BehaviorSubject("");
  sharedData = this.paramSource.asObservable();
  setParam(param: string) { this.paramSource.next(param) }

  timeTableValue: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);

  ELEMENT_DATA1ClassA: PeriodicElement[] = [
    { className: '1st maths', date: '2024-06-10', time: '10.15 AM', staffName: "qwerty" },
    { className: '1st english', date: '2024-06-10', time: '11.15 AM', staffName: "engqwerty" }
  ];

  ELEMENT_DATA1ClassB: PeriodicElement[] = [
    { className: '1st EVS', date: '2024-06-10', time: '10.15 AM', staffName: "qwerty" },
    { className: '1st Social', date: '2024-06-10', time: '11.15 AM', staffName: "engqwerty" }
  ];

  ELEMENT_DATA1ClassC: PeriodicElement[] = [
    { className: '1st EVS', date: '2024-06-10', time: '10.15 AM', staffName: "qwerty" },
    { className: '1st Social', date: '2024-06-10', time: '11.15 AM', staffName: "engqwerty" }
  ];

  ELEMENT_DATA2ClassA: PeriodicElement[] = [
    { className: '2st maths', date: '2024-06-10', time: '10.15 AM', staffName: "qwerty" },
    { className: '2st english', date: '2024-06-10', time: '11.15 AM', staffName: "engqwerty" }
  ];

  ELEMENT_DATA2ClassB: PeriodicElement[] = [
    { className: '2st EVS', date: '2024-06-10', time: '10.15 AM', staffName: "qwerty" },
    { className: '2st Social', date: '2024-06-10', time: '11.15 AM', staffName: "engqwerty" }
  ];

  ELEMENT_DATA2ClassC: PeriodicElement[] = [
    { className: '2st EVS', date: '2024-06-10', time: '10.15 AM', staffName: "qwerty" },
    { className: '2st Social', date: '2024-06-10', time: '11.15 AM', staffName: "engqwerty" }
  ];

  ELEMENT_DATA3ClassA: PeriodicElement[] = [
    { className: '3st maths', date: '2024-06-10', time: '10.15 AM', staffName: "qwerty" },
    { className: '3st english', date: '2024-06-10', time: '11.15 AM', staffName: "engqwerty" }
  ];

  ELEMENT_DATA3ClassB: PeriodicElement[] = [
    { className: '3st EVS', date: '2024-06-10', time: '10.15 AM', staffName: "qwerty" },
    { className: '3st Social', date: '2024-06-10', time: '11.15 AM', staffName: "engqwerty" }
  ];

  ELEMENT_DATA3ClassC: PeriodicElement[] = [
    { className: '3st EVS', date: '2024-06-10', time: '10.15 AM', staffName: "qwerty" },
    { className: '3st Social', date: '2024-06-10', time: '11.15 AM', staffName: "engqwerty" }
  ];


  convertToNewEvent(data: PeriodicElement[]): NewEvent[] {
    return data.map(item => ({
      title: item.className,
      start: `${item.date}T${this.formatTime(item.time)}`,
      extendedProps: {
        description: item.staffName
      }
    }));
  }

  private formatTime(time: any): string {
    const [hour, minute, period] = time.match(/(\d+)\.(\d+)\s(AM|PM)/).slice(1);
    let formattedHour = period === 'PM' && hour !== '12' ? parseInt(hour) + 12 : hour;
    formattedHour = period === 'AM' && hour === '12' ? '00' : formattedHour;
    return `${formattedHour.padStart(2, '0')}:${minute}:00`;
  }

  timeTableStudents: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([]);

  newEventData1ClassA = this.convertToNewEvent(this.ELEMENT_DATA1ClassA);
  newEventData1ClassB = this.convertToNewEvent(this.ELEMENT_DATA1ClassB);
  newEventData1ClassC = this.convertToNewEvent(this.ELEMENT_DATA1ClassC);

  newEventData2ClassA = this.convertToNewEvent(this.ELEMENT_DATA2ClassA);
  newEventData2ClassB = this.convertToNewEvent(this.ELEMENT_DATA2ClassB);
  newEventData2ClassC = this.convertToNewEvent(this.ELEMENT_DATA2ClassC);

  newEventData3ClassA = this.convertToNewEvent(this.ELEMENT_DATA3ClassA);
  newEventData3ClassB = this.convertToNewEvent(this.ELEMENT_DATA3ClassB);
  newEventData3ClassC = this.convertToNewEvent(this.ELEMENT_DATA3ClassC);
}

